// src/redux/reducers/menuManageReducer.js

import { combineReducers } from 'redux'

import noticeSlice from '../slice/order-ordering-slice/notice-slice'
import qrCodeSlice from '../slice/order-ordering-slice/qr-codes-slice'
import smartQrCodeSlice from '../slice/order-ordering-slice/smart-qr-codes-slice'
import availableItemsTabsReducer from '../slice/order-ordering-slice/availableItemSlice'
import websiteSettingsReducer from '../slice/order-ordering-slice/websiteSettingsSlice'
import orderStatusSlice from '../slice/order-ordering-slice/order-status-slice'
import reviewSlice from '../slice/order-ordering-slice/review-slice'
import depositSettingsSlice from '../slice/order-ordering-slice/deposit-settings-slice'
import tillOrderAccessSlice from '../slice/order-ordering-slice/till-order-access-slice'
import serviceChargeSlice from '../slice/order-ordering-slice/service-charge-slice'
import invoiceStatementSlice from '../slice/order-ordering-slice/invoice-statement-slice'

const onlineOrderReducer = combineReducers({
  notice: noticeSlice,
  availableItems: availableItemsTabsReducer,
  websiteSettings: websiteSettingsReducer,
  qrCodes: qrCodeSlice,
  smartQrCodes: smartQrCodeSlice,
  orderStatus: orderStatusSlice,
  reviews: reviewSlice,
  depositSettings: depositSettingsSlice,
  tillOrderAccess: tillOrderAccessSlice,
  serviceCharge: serviceChargeSlice,
  onlineOrderSettings: invoiceStatementSlice,
  invoiceStatement: invoiceStatementSlice
})

export default onlineOrderReducer
